export default "__VITE_ASSET__FPaW8xTI__"